import React from 'react';
import { useHistory } from 'react-router-dom';
import PopUp from '../PopUp/PopUp';

export const PopUpWithRedirect: React.FC = () => {
  const history = useHistory();

  const handleClose = () => {
    history.push('/');
  };

  return (
    <PopUp
      type="error"
      title="Błąd"
      notification="Nie posiadasz uprawnień do tej operacji lub strona nie istnieje."
      link={null}
      onClickEvent={null}
      closePopUp={handleClose}
      active={true}
    />
  );
};